module.exports = __webpack_public_path__ + "img/remove-user.dcbec224.svg";